import { Component, Input } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { DataFormModel } from '../../models/data-form-model.model';
import { Report } from '../../models/report.model';

import { ReportService } from '../../services/report.service';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-report-cancel-modal',
  templateUrl: './report-cancel-modal.component.html',
  styleUrl: './report-cancel-modal.component.scss'
})
export class ReportCancelModalComponent {

  @Input() report!: Report;

  /* REPORTS.cancelReason es VARCHAR(255): el tope se corta aquí porque el
     backend no valida el largo y pasarse revienta con 500. */
  public readonly reasonMaxLength: number = 255;

  public dataForm: DataFormModel = {
    cancelReason: {
      value: '',
      type: 'textarea',
      label: 'Motivo de la cancelación',
      placeholder: 'Reporte duplicado, atendido por otra vía, etc.',
      requiredMessage: 'Por favor, escriba el motivo de la cancelación',
      required: true,
      validators: [
        Validators.required,
        Validators.maxLength(this.reasonMaxLength)
      ]
    }
  };

  public formReportCancel!: FormGroup;
  public loading: boolean = false;
  public submitted: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public reportService: ReportService,
    public utilService: UtilService,
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  get f() {
    return this.formReportCancel.controls;
  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR loadData                              */
  /* -------------------------------------------------------------------------- */
  // region loadData
  async loadData() {

    this.loading = true;

    /* El motivo siempre arranca vacío: es una decisión nueva de quien cancela,
       no un dato del reporte que se pueda precargar. */
    this.formReportCancel = this.utilService.buildForm(this.dataForm);

    this.loading = false;

  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR onSubmit                              */
  /* -------------------------------------------------------------------------- */
  // region onSubmit
  async onSubmit() {

    /* El texto se recorta ANTES de validar. Validators.required da por bueno un
       motivo de solo espacios y el backend lo rechaza con 400: normalizar aquí
       hace que "   " caiga en el mismo error que un campo vacío y que el
       usuario vea el mensaje debajo del campo, no un toast de error. */
    const cancelReason = `${this.formReportCancel.value.cancelReason ?? ''}`.trim();

    this.formReportCancel.controls['cancelReason'].setValue(cancelReason);

    /* El botón de envío SIEMPRE está habilitado: la validación corre aquí y el
       error se pinta debajo del campo que lo provocó. */
    this.submitted = true;

    if(this.formReportCancel.invalid) {
      return;
    }

    const flag = await this.reportService.cancel(
      this.report,
      cancelReason
    );

    if(flag) {
      /* Se devuelve el motivo para que quien abrió el modal pueda reflejar la
         cancelación sin volver a preguntarle a la API. */
      this.activeModal.close(cancelReason);
    }

  }

}
